/**********************************************************************************
CHID       WHO              WHEN            WHY
********************************************************************************
//CHID-1     Mahesh        28/02/2020      2693: Facility Screen - Distance
//CHID-2     Mahesh        24/11/2020      3603: Translate opening hour text to French
*********************************************************************************/
import { withProps } from "@mna/react";
import Carousel from "@mna/react-ui/Carousel";
import Ellipsis from "@mna/react-ui/Ellipsis";
import IconPhone from "assets/icons/phone.svg";
import i18next from "i18next";
import { Trans } from "react-i18next";
import { commonConstant } from "../../server/triage/constants";

const ClinicCard = ({
  name,
  line_1,
  distance = 0,
  distanceUnit = "km",
  phone = "",
  todaysHours = "",
  hoursPerDay = [],
}) => {
   let openHours = todaysHours || hoursPerDay[0] || null;

  if (!openHours || openHours === commonConstant.Unknown || openHours === commonConstant.nullHours) {
    openHours = <Trans i18nKey="findcareoption.Careoptions.hoursUnknown">Open hours unknown</Trans>;
  }
  distance = distance.toFixed(2);
  let mile = distance * 0.621371;
  let miles = mile.toFixed(2);

  return (
    <div role="group" aria-label="facility" className="location-result-container">
      <div
        className="location-result flex flex-column"
        style={{ overflowY: "auto" }}
      >
        <div className="flex-grow">
          <h2 className="location-result-title">
            <a href="#">{name}</a>
          </h2>
        </div>
        <div>
          <div className="my-1">
            <Ellipsis className="location-result-address">{line_1}</Ellipsis>

            <Ellipsis className="location-result-address">
              {i18next.t("findcareoption.Careoptions.Distance")}:{" "}
              {distance + " " + distanceUnit + " / " + miles + " " + "Mi"}
            </Ellipsis>

            <Ellipsis className="location-result-hours">{openHours}</Ellipsis>
          </div>
          {phone !== null?
            <button
              type="button"
              className="call-button btn-pill bg-standby-blue color-white"
            >
              <div className="icon">
                <IconPhone />
              </div>
              <div className="call-text">
                <Trans i18nKey="findcareoption.Careoptions.Call">Call</Trans>
              </div>{" "}
              {phone}
            </button>
          :
          <div className="button-call-disabled">
          <button
              type="button"
              className="call-button btn-pill bg-standby-disable color-white"
            >
              <div className="icon">
                <IconPhone />
              </div>
              <div className="call-text">
                <Trans i18nKey="findcareoption.Careoptions.Call">Call</Trans>
              </div>
            </button>
            <label className="label-not-found">
            <Trans i18nKey="findcareoption.Careoptions.NotFound">Not found</Trans>
              </label>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

const ClinicsCarousel = ({
  clinics,
  numberOfCards,
  onCardClick,
  getInstance,
  onChange,
}) =>
  !clinics || !clinics.length ? null : (
    <div
      className={
        numberOfCards > 4
          ? "location-results-carousel-left"
          : "location-results-carousel"
      }
    ><fieldset>
      <Carousel
        {...{
          items: clinics.map((props, itemIndex) => (
            <div key={`result-${itemIndex}`}>
              <ClinicCard key={`location-result-${itemIndex}`} {...props} />
            </div>
          )),
          //cardCentered: false,
          cardWidth: 320,
          cardHeight: 155,
          //loop: false,
          //cardPadCount: 0 // 3 * 3 // Fill row width
          loop: numberOfCards > numberOfCards * 2,
          cardPadCount: 0, //(numberOfCards * 3),
          onCardClick,
          getInstance,
          onChange,
        }}
      />
    </fieldset>
    </div>
  );

export default withProps(({ clinics }) => ({
  numberOfCards: clinics.length,
}))(ClinicsCarousel);
